import { Col, Row, Typography } from "antd";
const { Text } = Typography;
const InfoRow = ({ label, value }) => (
    <Row gutter={16} className="info-row">
        <Col span={10}><Text strong>{label}:</Text></Col>
        <Col span={14}><Text>{value }</Text></Col>
    </Row>
);
export default InfoRow;